
import {Beneficiaire} from '../beneficiaire/beneficiaire.model';
import {Folders} from './folder.interface';
import FolderInterface = Folders.FolderInterface;
import {LineFolders} from './lineFolder.interface';
import LineFolderInterface = LineFolders.LineFolderInterface;
import {InfoReglementInterface} from "../consommation/infoReglement.interface";

export class Folder implements FolderInterface {
  id?: number;
  numero?: number;
  date?: string;
  datcre?: string;
  dateReference?: string;
  libelle?: string;
  source?: string;
  montantTrigger?: number;
  montantAttente?: number;
  montantValide?: number;
  montantPresente?: number;
  subvention?: number;
  remarquePublic?: string;
  remarquePrive?: string;
  typeAcceptation?: string;
  statutAdministratif?: Folders.StatusAdministratifEnum;
  lignes?: Array<LineFolderInterface>;
  beneficiaire?: Beneficiaire;
  ecritures?: Array<any>;
  usrcre?: string;
  usrmaj?: string;
  deletable?: boolean;
  infoReglement?: Array<InfoReglementInterface>;

  constructor({
                id = null,
                numero = null,
                date = null,
                datcre = null,
                dateReference = null,
                libelle = null,
                source = null,
                montantTrigger = null,
                montantValide = null,
                montantAttente = null,
                montantPresente = null,
                subvention = null,
                remarquePublic = null,
                remarquePrive = null,
                typeAcceptation = null,
                statutAdministratif = Folders.StatusAdministratifEnum.Attente,
                lignes = null,
                beneficiaire = null,
                ecritures = null,
                usrcre = null,
                usrmaj = null,
                deletable = null,
                infoReglement = null,
              }: FolderInterface) {
    this.id = id;
    this.numero = numero;
    this.date = date;
    this.datcre = datcre;
    this.dateReference = dateReference;
    this.libelle = libelle;
    this.source = source;
    this.montantTrigger = montantTrigger;
    this.montantValide = montantValide;
    this.montantAttente = montantAttente;
    this.montantPresente = montantPresente;
    this.subvention = subvention;
    this.remarquePublic = remarquePublic;
    this.remarquePrive = remarquePrive;
    this.typeAcceptation = typeAcceptation;
    this.statutAdministratif = statutAdministratif;
    this.lignes = lignes;
    this.beneficiaire = beneficiaire;
    this.ecritures = ecritures;
    this.usrcre = usrcre;
    this.usrmaj = usrmaj;
    this.deletable = deletable;
    this.infoReglement = infoReglement;
  }
}



// WEBPACK FOOTER //
// ./src/shared/models/folder/folder.model.ts